import React, { useState } from "react";
import { Edit, Delete } from "@mui/icons-material";
import { Tooltip, useTheme } from "@mui/material";

import { useSelector, useDispatch } from "react-redux";
import {
  changeExpansion,
  editPatientNote,
  onPatientNotesChange,
} from "app/store/transmission/slice/transmissionSlice";

const PatientNote = ({ note, index, rowData, onDelete }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [isNoteHovered, setIsNoteHovered] = useState(false);
  const { patientNotesSubmitting, currentPatientNote } = useSelector(
    (state) => state.transmission
  );

  const selected = currentPatientNote?.index === index || isNoteHovered;

  const handleEdit = (selectedIndex, selectedNote) => {
    dispatch(editPatientNote(true));
    dispatch(
      onPatientNotesChange({ index: selectedIndex, value: selectedNote })
    );
    dispatch(changeExpansion({ type: "patientNotes", value: true }));
  };

  return (
    <div
      key={index}
      className="view-pdf__notes-header--note"
      onMouseEnter={() => {
        if (!rowData?.legacy) {
          setIsNoteHovered(true);
        }
      }}
      onMouseLeave={() => {
        if (!rowData?.legacy) {
          setIsNoteHovered(false);
        }
      }}
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: selected
          ? theme.palette.type === "dark"
            ? "#333333"
            : "#f5f5f5"
          : "transparent",
      }}
    >
      {note}
      {isNoteHovered && !rowData?.legacy && !patientNotesSubmitting && (
        <div className="view-pdf__notes-actions">
          <Tooltip title="Edit note">
            <Edit
              fontSize="small"
              className="edit-btn"
              onClick={() => handleEdit(index, note)}
            />
          </Tooltip>
          <Tooltip title="Delete note">
            <Delete
              fontSize="small"
              className="delete-btn"
              onClick={() => onDelete(true, note, index)}
            />
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default PatientNote;
